import type React from "react";

import classNames from "classnames";

import styles from "./NaverClusterMarker.module.scss";

export const clusterMarkerSizes = ["XS", "S", "M", "L", "XL"] as const;
type NaverClusterMarkerType = (typeof clusterMarkerSizes)[number];

export type NaverClusterMarkerProps = {
  type: NaverClusterMarkerType;
};

export const NaverClusterMarker: React.FC<NaverClusterMarkerProps> = ({ type }) => {
  return (
    <div data-testid="naverClusterMarker" className={classNames(styles.wrapper, styles[`background${type}`])}></div>
  );
};
